import { render, staticRenderFns } from "./ModalityForm.vue?vue&type=template&id=13c9ca79&scoped=true"
import script from "./ModalityForm.vue?vue&type=script&lang=js"
export * from "./ModalityForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=13c9ca79&prod&scoped=true&lang=css&external"
import style1 from "./ModalityForm.vue?vue&type=style&index=1&id=13c9ca79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c9ca79",
  null
  
)

export default component.exports